import { render, staticRenderFns } from "./ActualitesWidgetIcon.vue?vue&type=template&id=523de532"
import script from "./ActualitesWidgetIcon.vue?vue&type=script&lang=js"
export * from "./ActualitesWidgetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports